import { ROUTES_EDIT_CLUB } from '@/constants/routes';
import store from '@/store';
import { guardRoute } from '@/router';

export default {
    path: '/edit-club',
    name: ROUTES_EDIT_CLUB,
    beforeEnter: guardRouteEditClub,
    meta: {
        requiresSpeedIntensities: true
    },
    component: () => import(/*webpackChunkName: 'edit-club'*/ '@/views/EditClub')
};

function guardRouteEditClub(to, from, next) {
    const unauthorized = !store.getters['userPermissions/canEditClub'];
    guardRoute(next, unauthorized);
}
